import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import * as cafeEventsActions from '../../../redux/cafeEvents/actions';
import * as cafeActions from '../../../redux/cafes/actions';
import RequestedCafeEventsTable from './requestedCafeEventsTable';
import RequestedCafeEventsFilter from './requestedCafeEventsFilter';
import Spin from '../../../components/loading';
import Pagination2 from '../../../components/Pagination2';
import submitForm from '../../../utils/submitForm';

class RequestedCafeEvents extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      cafeIds: [],
      itemsPerPage: 10,
      sortType: 'asc',
      sortBy: 'fromDate',
    };
  }

  componentDidMount() {
    const query = this.buildSearchQuery(this.state.currentPage, this.state.itemsPerPage);
    this.props.actions.fetchAllRequestedCafeEvents(query);
    this.props.actions.getAllCafeNamesForPanel();
  }

  buildSearchQuery = (pageNumber, pageSize) => {
    if (!isNaN(pageNumber) && !isNaN(pageSize)) {
      let query = `pageNumber=${pageNumber}&pageSize=${pageSize}`;
      query += `&${this.state.query || 'sort=fromDate-desc'}`;
      return query;
    }
  };

  onPageChanged = data => {
    const { currentPage, totalPages, pageLimit } = data;
    this.setState({ currentPage: currentPage }, () => {
      const query = this.buildSearchQuery(this.state.currentPage, this.state.itemsPerPage);
      this.props.actions.fetchAllRequestedCafeEvents(query);
    });
  };

  applyFilters = event => {
    const queryString = submitForm(
      event,
      this.state.selectedRegions,
      this.state.selectedAmenities,
      this.state.cafeIds,
    );
    this.setState({ filter: queryString }, () => this.filterAndSort());
  };

  filterAndSort = () => {
    let { filter, sort } = this.state;
    let query;
    if (sort && filter) query = `${filter}&${sort}`;
    else if (filter) query = `${filter}`;
    else if (sort) query = `${sort}`;
    this.setState({ query, currentPage: 1 }, () => {
      let searchQuery = this.buildSearchQuery(this.state.currentPage, this.state.itemsPerPage);
      this.props.actions.fetchAllRequestedCafeEvents(searchQuery);
    });
  };

  onSelectCafeIds = cafeIds => this.setState({ cafeIds: cafeIds ? [...cafeIds] : [] });

  render() {
    let {
      requestedCafeEventsLoading,
      requestedCafeEventsMessage,
      requestedCafeEventsFailed,
      requestedCafeEventsError,
    } = this.props;
    let { totalRecords } = this.props.requestedCafeEvents;
    let { currentPage, itemsPerPage, sortType } = this.state;
    return (
      <>
        <div className="col-12 d-flex justify-content-between align-items-center">
          <h3 className="text-right text-muted py-4">
            <div className="text-right">{locales('titles.requestedCafeEvents')}</div>
          </h3>
        </div>
        <section className="p-1 col-12">
          <Spin spinning={requestedCafeEventsLoading}>
            <article>
              <main className="panel panel-default">
                {requestedCafeEventsError ? (
                  <div className="alert alert-danger">{locales('messages.server.error')}</div>
                ) : (
                  <>
                    {requestedCafeEventsFailed && (
                      <div className="alert alert-danger">{requestedCafeEventsMessage}</div>
                    )}
                    <div className="panel-heading">
                      <i className="fas fa-list-alt px-1"/>
                      {locales('titles.requestedCafeEventsList')}
                    </div>
                    <div className="panel-body">
                      <RequestedCafeEventsFilter
                        onSelectCafeIds={this.onSelectCafeIds}
                        applyFilters={this.applyFilters}
                        filterAndSort={this.filterAndSort}
                        cafeNamesList={this.props.cafeNamesList}
                      />
                      <RequestedCafeEventsTable pageNumber={currentPage} pageSize={itemsPerPage}
                                                buildSearchQuery={this.buildSearchQuery}/>
                      <footer className="col-12 d-flex justify-content-center py-2">
                        <div className="pagination-container">
                          <Pagination2
                            totalRecords={totalRecords || 0}
                            pageLimit={itemsPerPage}
                            pageNeighbours={2}
                            onPageChanged={this.onPageChanged}
                            currentPage={this.state.currentPage}
                          />
                        </div>
                      </footer>
                    </div>
                  </>
                )}
              </main>
            </article>
          </Spin>
        </section>
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    requestedCafeEventsList: state.cafeEventsReducer.requestedCafeEventsList,
    requestedCafeEvents: state.cafeEventsReducer.requestedCafeEvents,
    loading: state.cafeEventsReducer.requestedCafeEventsLoading,
    message: state.cafeEventsReducer.requestedCafeEventsMessage,
    failed: state.cafeEventsReducer.requestedCafeEventsFailed,
    error: state.cafeEventsReducer.requestedCafeEventsError,

    cafeNamesLoading: state.cafesReducer.cafeNamesLoading,
    cafeNamesList: state.cafesReducer.cafeNamesList,
    cafeNamest: state.cafesReducer.cafeNames,
    cafeNamesFailed: state.cafesReducer.cafeNamesFailed,
    cafeNamesMessage: state.cafesReducer.cafeNamesMessage,
    cafeNamesError: state.cafesReducer.cafeNamesError,

    cafeNamesListLoading: state.cafesReducer.cafeNamesListLoading,
    cafeNamesListFailed: state.cafesReducer.cafeNamesListFailed,
    cafeNamesListMessage: state.cafesReducer.cafeNamesListMessage,
    cafeNamesListError: state.cafesReducer.cafeNamesListError,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      fetchAllRequestedCafeEvents: query => dispatch(cafeEventsActions.fetchAllRequestedCafeEvents(query)),
      getAllCafeNamesForPanel: () => dispatch(cafeActions.getAllCafeNamesForPanel()),
    },
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RequestedCafeEvents));
